import React from "react";
import {
  FaChild,
  FaFileAlt,
  FaClipboardCheck,
  FaMoneyBillWave,
  FaClock,
  FaBookOpen,
  FaCheckCircle,
} from "react-icons/fa";
const studentGroups = [
  ["Pupa (Play Group)", "2 & Half +"],
  ["Caterpillar (LKG)", "3 & Half +"],
  ["Butterfly (UKG)", "4 & Half +"],
  ["Class I", "5 & Half +"],
  ["Class VI", "Passes Class 5th"],
  ["Class IX", "Passed Class 8th"],
];
const admissionBasis = [
  "Entrance Test of respective class",
  "Physically fit and mentally sound",
  "Passed previous class",
  "Dialogue with the parent of the child",
];

const documents = [
  "Birth certificate as proof of age",
  "Completely filled admission form with photograph",
  "Two passport size photographs",
  "Report Card / Progress Report from last school",
];
const timings = [
  {
    term: "I - Term",
    months: "April - September",
    time1: "PG to Nursery: 8.00 am to 12.00 noon",
    time2: "Class LKG to IX: 8.00 am to 1.00 pm",
  },
  {
    term: "II - Term",
    months: "October - March",
    time1: "PG to Nursery: 9.00 am to 12.30 pm",
    time2: "Class LKG to IX: 9.00 am to 1.30 pm",
  },
];
const AdmissionProcedure = () => {
  return (
    <section className="relative py-20 px-4 md:px-8 bg-gradient-to-br from-orange-50 via-white to-red-50 overflow-hidden">
      <div className="absolute top-0 left-0 w-72 h-72 bg-orange-300/20 rounded-full blur-3xl -translate-x-24"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-red-300/20 rounded-full blur-3xl translate-x-24"></div>

      <div className="relative max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-5 py-2 text-sm font-semibold text-red-600 bg-red-100 rounded-full mb-4">
            Procedure
          </span>
          <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900">
            Admission{" "}
            <span className="bg-gradient-to-r from-red-600 to-orange-500 bg-clip-text text-transparent">
              Procedure
            </span>
          </h2>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto leading-7">
            Complete admission details including age criteria, required
            documents, fee information, timings and curriculum.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-[0.95fr_1.05fr] gap-8 items-start">
          <div className="bg-gradient-to-br from-red-600 to-orange-500 rounded-[32px] p-7 md:p-9 text-white shadow-2xl">
            <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center text-3xl mb-6">
              <FaChild />
            </div>
            <h3 className="text-3xl md:text-4xl font-extrabold mb-6">
              Student Groups
            </h3>
            <div className="space-y-3">
              {studentGroups.map((item, index) => (
                <div
                  key={index}
                  className="flex justify-between gap-4 bg-white/15 border border-white/20 rounded-2xl p-4"
                >
                  <span className="text-sm font-semibold">{item[0]}</span>
                  <span className="text-sm font-bold text-yellow-100">
                    {item[1]}
                  </span>
                </div>
              ))}
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div className="bg-white rounded-[26px] p-6 shadow-xl border border-orange-100">
              <div className="flex items-center gap-3 mb-4">
                <FaClipboardCheck className="text-red-500 text-2xl" />
                <h3 className="text-xl font-bold text-gray-900">
                  Admission Basis
                </h3>
              </div>
              <ul className="space-y-3">
                {admissionBasis.map((item, index) => (
                  <li key={index} className="flex gap-3 text-sm text-gray-600">
                    <FaCheckCircle className="text-orange-500 shrink-0 mt-1" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="bg-white rounded-[26px] p-6 shadow-xl border border-orange-100">
              <div className="flex items-center gap-3 mb-4">
                <FaFileAlt className="text-red-500 text-2xl" />
                <h3 className="text-xl font-bold text-gray-900">
                  Documents Required
                </h3>
              </div>
              <ul className="space-y-3">
                {documents.map((item, index) => (
                  <li key={index} className="flex gap-3 text-sm text-gray-600">
                    <FaCheckCircle className="text-orange-500 shrink-0 mt-1" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="bg-white rounded-[26px] p-6 shadow-xl border border-orange-100 md:col-span-2">
              <div className="flex items-center gap-3 mb-4">
                <FaMoneyBillWave className="text-red-500 text-2xl" />
                <h3 className="text-xl font-bold text-gray-900">
                  Fee & Registration
                </h3>
              </div>
              <p className="text-gray-600 text-sm leading-7">
                One Time Registration Fee of{" "}
                <strong className="text-red-600">Rs. 3200</strong> will be
                charged at the time of admission and{" "}
                <strong className="text-red-600">Rs. 1000</strong> deposit as
                Caution Money. The Caution Money will be refunded at the time of
                exit from the School.
              </p>
            </div>
            <div className="bg-white rounded-[26px] p-6 shadow-xl border border-orange-100 md:col-span-2">
              <div className="flex items-center gap-3 mb-4">
                <FaClock className="text-red-500 text-2xl" />
                <h3 className="text-xl font-bold text-gray-900">
                  School Timings
                </h3>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {timings.map((item, index) => (
                  <div
                    key={index}
                    className="bg-gradient-to-r from-orange-50 to-red-50 rounded-2xl p-4 border border-orange-100"
                  >
                    <h4 className="text-lg font-bold text-red-600">
                      {item.term}
                    </h4>
                    <p className="text-xs font-semibold text-gray-500 mb-3">
                      {item.months}
                    </p>
                    <p className="text-sm text-gray-600 leading-7">
                      {item.time1}
                    </p>
                    <p className="text-sm text-gray-600 leading-7">
                      {item.time2}
                    </p>
                    <p className="text-xs text-gray-500 mt-2">
                      Sunday Closed
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className="bg-gradient-to-r from-red-600 to-orange-500 rounded-[26px] p-6 shadow-xl text-white md:col-span-2">
              <div className="flex items-center gap-3 mb-3">
                <FaBookOpen className="text-2xl" />
                <h3 className="text-xl font-bold">Course Curriculum</h3>
              </div>
              <p className="text-white/90 text-sm leading-7">
                The courses are based on CBSE Pattern with examination based on
                grading system. The medium of teaching is strictly English.
              </p>
            </div>
          </div>
        </div>
        <div className="mt-8 bg-white rounded-[28px] p-6 md:p-7 shadow-xl border border-orange-100">
          <h3 className="text-xl font-bold text-gray-900 mb-3">
            Withdrawal Procedure
          </h3>
          <p className="text-gray-600 text-sm md:text-[15px] leading-8">
            For withdrawal, an application for Leaving Certificate shall be made
            in writing by the parent or guardian at the end of session after
            clearing all dues, if any. However, in special circumstances,
            withdrawal in mid-session may be allowed by the Principal on
            sufficient and valid grounds.
          </p>
        </div>
      </div>
    </section>
  );
};
export default AdmissionProcedure;